import React from "react";
import "./PageNotFound.scss";
import { SeemaError } from "../../components";
import { TextButton } from "../../controls";

interface PageNotFoundProps {
  title?: string;
  subtitle?: string;
  description?: string;
  callToAction?: React.ReactNode;
  showReachOutButton?: boolean;
  isSmall?: boolean;
  onReachOutButtonClick?: () => void;
}

const PageNotFound: React.FC<PageNotFoundProps> = ({
  title,
  subtitle,
  description,
  callToAction = null,
  showReachOutButton = true,
  isSmall = false,
  onReachOutButtonClick = () => {},
}) => (
  <div className={`page-not-found ${isSmall ? "small" : ""}`}>
    <SeemaError className={"seema-error-img"} />
    {title && <h1 className="page-not-found-title">{title}</h1>}
    {!!subtitle && (
      <h4 className={"page-not-found-subtitle no-margin"}>{subtitle}</h4>
    )}
    {!!description && (
      <p className="page-not-found-description">{description}</p>
    )}
    {!!callToAction && <div className={"actions-wrapper"}>{callToAction}</div>}
    {showReachOutButton && (
      <div className="help-section">
        <div className="text">Still lost? Feel free to</div>{" "}
        <TextButton
          buttonStyle={"textLink"}
          label={"reach out"}
          wrapperClassName={"reach-out-button"}
          onClick={onReachOutButtonClick}
        />
        .
      </div>
    )}
  </div>
);

export default PageNotFound;
